import React from 'react';
import {  Nav } from './Navbar.styled';
import { withRouter } from 'react-router-dom'
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

const DocumentProgressBar = ()  => {
    const { t } = useTranslation();
    const documentData =  useSelector((state) => state.theme.documentData)
    const getActiveBar = (value) => {
        return documentData?.documentStep >= value && 'active'
    }
    return (
            <Nav>
              <div className="progress-wrapper">
                        <h3>{documentData?.title}</h3>
                        <ul className="progressbar">
                            <li className={ getActiveBar(1) }>{t('PROGRESS_TEXT')}</li>
                            <li className={ getActiveBar(2) }></li>
                            <li className={ getActiveBar(3) }></li>
                        </ul>
                    </div>
            </Nav>
    )
}
export default withRouter(DocumentProgressBar);